import { Box, Button, Grid, InputLabel, Link, makeStyles, Typography } from '@material-ui/core'
import { Cancel, CloudUpload } from '@material-ui/icons'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ObjectToFormdata } from '../../../Common/Utils/common_utils'
import CustomInput from '../../../Components/CustomInput'
import CustomMultiSelectAutoComplete from '../../../Components/CustomMultiSelectAutoComplete'
import CustomSelect from '../../../Components/CustomSelect'
import { GLOBAL_STEPPER_DATA } from '../../../Redux/actions'
import AdminPartnerClient from '../../../Service/Admin/partner_services'
import Header from './header'
import AddToListModal from "../../../Components/FormGenerator/addToListModal";
import { showSnackbar } from '../../../Components/Snackbar/SnackbarActions'
import StepperService from './StepperService'
import { mappedKeyJSON } from './MappedKeyJSON'
import CustomSelectMulti from '../../../Components/CustomSelectMulti'
import CircularIndeterminate from '../../../Components/Loader'

const MentoringProfile = (props: any) => {
  const classes = useStyles();
  const data = {
    overview: "",
    approach: "",
    background: "",
    // client_specific_areas_of_expertise: '',
    representative_engagements: "",
    representative_clients: "",
    education_and_qualifications: "",
    development_and_supervision: "",
    personal_interests: "",
    client_testimonials: "",
    clients_mentored: "",
  };

  const [userData, setUserData] = useState(data);
  const areasExpertiseArr = ["aa", "bb", "cc"];
  const [mentoringAreasArr, setMentoringAreasArr]: any = useState([]);
  const [mentoringAreas_attribute, setMentoringAreas_Attribute]: any = useState(
    []
  );
  const [photoArr, setPhotoArr]: any = useState([]);

  const global_data = useSelector((state: any) => state.stepperReducer);
  const global_data_common = useSelector((state: any) => state.commonReducer);
  const dispatch = useDispatch();
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [showAddNewModalExist, setShowAddNewModalExist] = useState(false);
  const [addNewModalProps, setAddNewModalProps] = useState({});
  const [TypeOfClientListsArr, setTypeOfClientListsArr]: any = useState([]);
  const [TypeOfClientLists_attribute, setTypeOfClientLists_attribute]: any =
    useState([]);
  const [diagnosticToolsArr, setDiagnosticToolsArr]: any = useState([]);
  const [diagnosticTools_attribute, setDiagnosticTools_attribute]: any =
    useState([]);
  const [
    professionalAffiliationsListsArr,
    setProfessionalAffiliationsListsArr,
  ]: any = useState([]);
  const [
    professionalAffiliationsLists_attribute,
    setProfessionalAffiliationsLists_attribute,
  ]: any = useState([]);
  const [languageListsArr, setLanguageListsArr]: any = useState([]);
  const [languages_attribute, setLanguages_attribute]: any = useState([]);
  const [addNewFlag, setAddNewFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);

  //    const globaluserData = useSelector((state) => state.commonReducer);
  //    const role = globaluserData?.role;
  let role = sessionStorage.getItem("role");

  const addNewHandler = (
    addNewModalExistFlag: any,
    modalFlag: any,
    addNewModalPropsData: any
  ) => {
    setShowAddNewModalExist(addNewModalExistFlag);
    setShowAddNewModal(modalFlag);
    setAddNewModalProps({ ...addNewModalProps, ...addNewModalPropsData });
  };

  const setInputState = (inputStateValue: any, inputId: any) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
    console.log(inputStateValue);
  };
  const onChangeItem = (
    selectedItemValue: any,
    inputId: any,
    routeFrom: any
  ) => {
    if (routeFrom == "add_in_drop_down") {
      setUserData({ ...userData, [inputId]: selectedItemValue });
      setAddNewFlag(true);
    } else {
      setUserData({
        ...userData,
        [selectedItemValue.id]: selectedItemValue.value,
      });
    }
  };
  const onChangeMultipleItem = (inputStateValue: any, inputId: any) => {
    console.log(inputStateValue);
    if (inputId == "mentoringAreas_attributes") {
      mentoringAreas_attribute.length = 0;
      setMentoringAreas_Attribute(
        mentoringAreas_attribute.concat(inputStateValue)
      );
    }
    if (inputId == "languages_attributes") {
      languages_attribute.length = 0;
      // setLanguages_attribute(languages_attribute.concat((obj)))
    }
  };
  const onChangeMultiItem = (
    obj: any,
    inputId: any,
    routeFrom: any,
    objId: any
  ) => {
    if (routeFrom == "add_in_drop_down") {
      // console.log(`routefrom=====`, obj,inputId: any, routeFrom)
      if (inputId == "TypeOfClientLists_attribute") {
        // TypeOfClientLists_attribute.length = 0
        setTypeOfClientLists_attribute(
          TypeOfClientLists_attribute.concat({
            id: objId,
            value: obj,
            label: obj,
          })
        );
      }
      if (inputId == "mentoringAreas_attributes") {
        // mentoringAreas_attribute.length = 0
        setMentoringAreas_Attribute(
          mentoringAreas_attribute.concat({ id: objId, value: obj, label: obj })
        );
      }
      if (inputId == "professionalAffiliationsLists_attribute") {
        // professionalAffiliationsLists_attribute.length = 0
        setProfessionalAffiliationsLists_attribute(
          professionalAffiliationsLists_attribute.concat({
            id: objId,
            value: obj,
            label: obj,
          })
        );
      }
      setAddNewFlag(true);
    } else {
      if (inputId == "TypeOfClientLists_attribute") {
        TypeOfClientLists_attribute.length = 0;
        setTypeOfClientLists_attribute(TypeOfClientLists_attribute.concat(obj));
      }
      if (inputId == "professionalAffiliationsLists_attribute") {
        professionalAffiliationsLists_attribute.length = 0;
        setProfessionalAffiliationsLists_attribute(
          professionalAffiliationsLists_attribute.concat(obj)
        );
      }
      if (inputId == "mentoringAreas_attributes") {
        mentoringAreas_attribute.length = 0;
        setMentoringAreas_Attribute(mentoringAreas_attribute.concat(obj));
      }

      if (inputId == "languages_attributes") {
        languages_attribute.length = 0;
        setLanguages_attribute(languages_attribute.concat(obj));
      }
      if (inputId == "diagnosticTools_attributes") {
        diagnosticTools_attribute.length = 0;
        setDiagnosticTools_attribute(diagnosticTools_attribute.concat(obj));
      }
    }
  };

  useEffect(() => {
    console.log(
      `global_data_common.partnerDropdowns`,
      global_data_common.partnerDropdowns
    );
    // if (TypeOfClientLists_attribute == "" && userData.professional_affiliations == "" && userData.diagnostic_tools == "") {
    languageListsArr.length = 0;
    setLanguageListsArr(
      languageListsArr.concat(
        global_data_common.partnerDropdowns[mappedKeyJSON.Language]
      )
    );

    diagnosticToolsArr.length = 0;
    setDiagnosticToolsArr(
      diagnosticToolsArr.concat(
        global_data_common.partnerDropdowns[mappedKeyJSON.DiagnosticTools]
      )
    );

    TypeOfClientListsArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[mappedKeyJSON.ClientType],
      {
        id: global_data_common.partnerDropdowns[mappedKeyJSON.ClientType] + 1,
        value: "+ Add New",
      },
    ];
    setTypeOfClientListsArr(TypeOfClientListsArr.concat(pdata));

    professionalAffiliationsListsArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[
        mappedKeyJSON.ProfessionalAffiliation
      ],
      {
        id:
          global_data_common.partnerDropdowns[
            mappedKeyJSON.ProfessionalAffiliation
          ] + 1,
        value: "+ Add New",
      },
    ];
    setProfessionalAffiliationsListsArr(
      professionalAffiliationsListsArr.concat(pdata)
    );

    mentoringAreasArr.length = 0;
    var pdata = [
      ...global_data_common.partnerDropdowns[
        mappedKeyJSON.MentoringAreasOfExpertise
      ],
      {
        id:
          global_data_common.partnerDropdowns[
            mappedKeyJSON.MentoringAreasOfExpertise
          ] + 1,
        value: "+ Add New",
      },
    ];
    setMentoringAreasArr(mentoringAreasArr.concat(pdata));

    if (!addNewFlag && global_data.mentoring_profile_id != null) {
      setLoading(true);
      AdminPartnerClient.MentoringProfile(
        global_data.mentoring_profile_id,
        { partner_profile_id: global_data.partner_profile },
        "GET"
      )
        .then((response: any) => {
          setUserData({
            overview: response.data.overview,
            approach: response.data.approach,
            background: response.data.background,
            // client_specific_areas_of_expertise: response.data.client_specific_areas_of_expertise,
            representative_engagements:
              response.data.representative_engagements,
            //types_of_clients: StepperService.getValueFromArrById(global_data_common.partnerDropdowns[mappedKeyJSON.ClientType], response.data.types_of_client_id),
            representative_clients: response.data.representative_clients,
            education_and_qualifications:
              response.data.education_and_qualifications,
            development_and_supervision:
              response.data.development_and_supervision,
            personal_interests: response.data.personal_interests,
            client_testimonials: response.data.client_testimonials,
            clients_mentored: response.data.clients_mentored,
          });
          StepperService.getValueFromArrayForCombobox1(
            response.data.partner_ment_languages,
            global_data_common.partnerDropdowns[mappedKeyJSON.Language],
            setLanguages_attribute,
            languages_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.diagnostic_tool_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.DiagnosticTools],
            setDiagnosticTools_attribute,
            diagnosticToolsArr
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.partner_ment_expertises,
            global_data_common.partnerDropdowns[
              mappedKeyJSON.MentoringAreasOfExpertise
            ],
            setMentoringAreas_Attribute,
            mentoringAreas_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.types_of_client_id,
            global_data_common.partnerDropdowns[mappedKeyJSON.ClientType],
            setTypeOfClientLists_attribute,
            TypeOfClientLists_attribute
          );
          StepperService.getValueFromArrayForCombobox1(
            response.data.professional_affiliation_id,
            global_data_common.partnerDropdowns[
              mappedKeyJSON.ProfessionalAffiliation
            ],
            setProfessionalAffiliationsLists_attribute,
            professionalAffiliationsLists_attribute
          );

          // if (response.data.partner_faci_expertises.length > 0) {
          //     partnerRolesArr.length = 0;
          //     response.data.partner_faci_expertises.map((options: any) => {
          //         setPartnerRolesArr(partnerRolesArr.push(options.areas_of_expertise));
          //     })
          // }
          if (
            response.data.picture_file_name != null &&
            response.data.picture_url != null
          ) {
            var localArr = [];
            var pdata = {
              attributes: {
                created_at: "T",
                file_name:
                  response.data.picture_file_name == null
                    ? "Name not found"
                    : response.data.picture_file_name,
                url: response.data.picture_url,
              },
              id: 0,
            };
            localArr.push(pdata);
            photoArr.length = 0;
            setPhotoArr(photoArr.concat(localArr));
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });

      // }
    }
  }, [addNewFlag]);
  const firstElementRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (firstElementRef.current) {
      //@ts-ignore
      firstElementRef.current.scrollIntoView();
    }
  }, []);
  const onSubmit = () => {
    var flag = true;
    if (
      role !== "admin" &&
      (userData.overview == "" ||
        userData.approach == "" ||
        // userData.background == "" ||
        // userData.client_specific_areas_of_expertise == "" ||
        userData.representative_engagements == "" ||
        userData.clients_mentored == "" ||
        // userData.education_and_qualifications == "" ||
        userData.client_testimonials == "" ||
        userData.representative_clients == "" ||
        // userData.development_and_supervision == "" ||
        // TypeOfClientLists_attribute.length == 0 ||
        // professionalAffiliationsLists_attribute.length == 0 ||
        // userData.personal_interests == "" ||
        // languages_attribute.length == 0 ||
        // photoArr.length == 0 ||
        mentoringAreas_attribute.length == 0)
      // diagnosticTools_attribute.length == 0
    ) {
      flag = false;
    }
    if (flag) {
      console.log(mentoringAreasArr);

      var pLocalArr: any = [];
      photoArr.map((option: any) => {
        pLocalArr.push(option.attributes.document);
      });
      console.log(languages_attribute);

      var langArr: any =
        languages_attribute[0] != undefined &&
        languages_attribute.map((option: any) => option.id);
      var diagnostic_toolArr: any =
        diagnosticTools_attribute[0] != undefined &&
        diagnosticTools_attribute.map((option: any) => option.id);
      var typeOfClient_Arr: any =
        TypeOfClientLists_attribute[0] != undefined &&
        TypeOfClientLists_attribute.map((option: any) => option.id);
      var professionalAffiliations_Arr: any =
        professionalAffiliationsLists_attribute[0] != undefined &&
        professionalAffiliationsLists_attribute.map((option: any) => option.id);
      var mentoringLocalArr: any =
        mentoringAreas_attribute[0] != undefined &&
        mentoringAreas_attribute.map((option: any) => option.id);

      var postData = {
        ...userData,
        picture: pLocalArr[0],
        areas_of_expertise_attribute:
          mentoringLocalArr.length > 0
            ? JSON.stringify(mentoringLocalArr)
            : "[]",
        languages_attribute:
          langArr.length > 0 ? JSON.stringify(langArr) : "[]",
        diagnostic_tool_id:
          diagnostic_toolArr.length > 0
            ? JSON.stringify(diagnostic_toolArr)
            : "[]",
        types_of_client_id:
          typeOfClient_Arr.length > 0 ? JSON.stringify(typeOfClient_Arr) : "[]",
        professional_affiliation_id:
          professionalAffiliations_Arr.length > 0
            ? JSON.stringify(professionalAffiliations_Arr)
            : "[]",
      };
      setLoading(true);
      setSubmitClickFlag(false);

      if (global_data.mentoring_profile_id == null) {
        AdminPartnerClient.MentoringProfile(
          "",
          ObjectToFormdata({
            partner_profile_id: global_data.partner_profile,
            ...postData,
          }),
          "POST"
        )
          .then((response: any) => {
            dispatch({
              type: GLOBAL_STEPPER_DATA,
              payload: { mentoring_profile_id: response.data.id },
            });
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information saved successfully"])
            );
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        AdminPartnerClient.MentoringProfile(
          global_data.mentoring_profile_id,
          ObjectToFormdata({
            partner_profile_id: global_data.partner_profile,

            ...postData,
          }),
          "PUT"
        )
          .then(() => {
            props.parentHandleNext(props.activeIndex + 1);
            dispatch(
              showSnackbar("Success", ["Information updated successfully"])
            );
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    } else {
      setSubmitClickFlag(true);
    }
  };

  const onBack = () => {
    props.parentHandleNext(props.activeIndex - 1);
  };
  const onImageChange = (event: any, id: any) => {
    console.log(id);
    var localArr = [];
    var pdata = {
      attributes: {
        document: event.target.files[0],
        created_at: "2021-04-08T12:06:08.000Z",
        file_name: event.target.files[0].name,
      },

      id: photoArr.length + 1,
    };
    localArr.push(pdata);
    setPhotoArr(photoArr.concat(localArr));
  };

  const deleteCard = (e: any, index: any, arr: any) => {
    StepperService.deleteUploadedImageCard(
      e,
      index,
      arr,
      setPhotoArr,
      photoArr
    );
  };
  return (
    <div style={{ marginBottom: 40 }} ref={firstElementRef}>
      {/* <Header parentcall={onSubmit} /> */}

      <Grid
        container
        direction='row'
        alignItems='flex-start'
        style={{ padding: 30, marginBottom: 30 }}
      >
        <Grid item xs={10}>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Mentoring overview{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='overview'
                variant='outlined'
                placeholder='Mentoring overview'
                multiline={true}
                rows={4}
                helperText={
                  submitClickFlag && userData.overview == ""
                    ? "Please enter mentoring overview"
                    : ""
                }
                error={
                  submitClickFlag && userData.overview == "" ? true : false
                }
                parentcall={setInputState}
                value={userData.overview}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Mentoring approach{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='approach'
                variant='outlined'
                placeholder='Mentoring approach'
                multiline={true}
                rows={4}
                helperText={
                  submitClickFlag && userData.approach == ""
                    ? "Please enter mentoring approach"
                    : ""
                }
                error={
                  submitClickFlag && userData.approach == "" ? true : false
                }
                parentcall={setInputState}
                value={userData.approach}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Mentoring areas of expertise{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomSelectMulti
                id='mentoringAreas_attributes'
                itemArr={mentoringAreasArr}
                parentcall={onChangeMultiItem}
                placeholder='Select mentoring areas of expertise'
                drop_down='MentoringAreasOfExpertise'
                addNewHandler={addNewHandler}
                field_name='mentoring_areas_of_expertise'
                addNewFlag={true}
                helperText={
                  submitClickFlag && mentoringAreas_attribute.length == 0
                    ? "Please select mentoring areas"
                    : ""
                }
                error={
                  submitClickFlag && mentoringAreas_attribute.length == 0
                    ? true
                    : false
                }
                value={mentoringAreas_attribute}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Representative mentoring engagements{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='representative_engagements'
                variant='outlined'
                placeholder='Representative mentoring engagements'
                parentcall={setInputState}
                multiline={true}
                rows={4}
                helperText={
                  submitClickFlag && userData.representative_engagements == ""
                    ? "Please enter representative engagements"
                    : ""
                }
                error={
                  submitClickFlag && userData.representative_engagements == ""
                    ? true
                    : false
                }
                value={userData.representative_engagements}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Levels of clients mentored{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='clients_mentored'
                variant='outlined'
                placeholder='Levels of clients mentored'
                parentcall={setInputState}
                multiline={true}
                rows={4}
                helperText={
                  submitClickFlag && userData.clients_mentored == ""
                    ? "Please enter levels of clients mentored"
                    : ""
                }
                error={
                  submitClickFlag && userData.clients_mentored == ""
                    ? true
                    : false
                }
                value={userData.clients_mentored}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Representative clients{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='representative_clients'
                variant='outlined'
                placeholder='Representative clients'
                parentcall={setInputState}
                multiline={true}
                rows={4}
                helperText={
                  submitClickFlag && userData.representative_clients == ""
                    ? "Please enter representative clients"
                    : ""
                }
                error={
                  submitClickFlag && userData.representative_clients == ""
                    ? true
                    : false
                }
                value={userData.representative_clients}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            alignItems='center'
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant='h2'>
                Client mentoring testimonials{role != "admin" ? "*" : ""}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id='client_testimonials'
                variant='outlined'
                placeholder='Client mentoring testimonials'
                parentcall={setInputState}
                multiline={true}
                rows={4}
                helperText={
                  submitClickFlag && userData.client_testimonials == ""
                    ? "Please enter client mentoring testimonials"
                    : ""
                }
                error={
                  submitClickFlag && userData.client_testimonials == ""
                    ? true
                    : false
                }
                value={userData.client_testimonials}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Header
        saveBtnTitle={"Save and proceed"}
        isBack={true}
        parentcall={onSubmit}
        parentBackCall={onBack}
      />
      {showAddNewModalExist && showAddNewModal && (
        <AddToListModal
          type='partner_profiles'
          postData={{ ...addNewModalProps }}
        />
      )}
      {loading && <CircularIndeterminate />}
    </div>
  );
}
export default MentoringProfile
const useStyles = makeStyles((theme) => ({
    labelText: {
        color: '#4D4F5C',
        fontSize: '16px',
        lineHeight: '22px',
        paddingRight: '10px'
    },
}))
